import { AuthSandbox } from './core/auth/auth.sandbox';
import { AuthApiService } from './core/auth/auth.service';
import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';

import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { HTTP_INTERCEPTORS, HttpClientModule } from '@angular/common/http';
import { RequestInterceptor, HTTPStatus } from './core/providers/interceptor/request.interceptor';
import { ToastrModule } from 'ngx-toastr';
import { SharedModule } from './default/shared/shared.module';
import { LayoutComponent } from './default/common/layout/layout.component';
import { reducers, metaReducers } from '../app/core/app.reducer';
import { EffectsModule } from '@ngrx/effects';
import { StoreModule } from '@ngrx/store';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { AuthGuard } from './core/providers/guards/auth-guard';
import { MediaSandbox } from './core/media/media.sandbox';
import { MediaEffects } from './core/media/effects/media.effect';
import { LocationStrategy, PathLocationStrategy } from '@angular/common';
import { CommonSandbox } from './core/common/common.sandbox';
import { CommonService } from './core/common/common.service';
import { CommonEffect } from './core/common/effects/common.effect';
import { AuthEffects } from './core/auth/effects/auth.effect';
import { NgbDateParserFormatter } from '@ng-bootstrap/ng-bootstrap';
import { NgbDateCustomParserFormatter } from './default/shared/interfaces/dateformat';
import { InfiniteScrollModule } from 'ngx-infinite-scroll';
import {ConnectionServiceModule} from 'ng-connection-service';
import { MaintenanceComponent } from './maintenance/maintenance.component';
import { NotFoundPage } from './default/common/not-found-page/not-found-page.component';
@NgModule({
  declarations: [
    AppComponent,
    LayoutComponent,
    MaintenanceComponent,
    NotFoundPage
  ],
  imports: [
    BrowserModule,
    AppRoutingModule,
    SharedModule,
    BrowserAnimationsModule,
    InfiniteScrollModule,
    HttpClientModule,
    ConnectionServiceModule,
    StoreModule.forRoot(reducers, { metaReducers, runtimeChecks: { strictStateImmutability: false, strictActionImmutability: false } }),
    EffectsModule.forRoot([MediaEffects, CommonEffect, AuthEffects]),
    ToastrModule.forRoot({
      timeOut: 2000,
      easing: 'ease-in',
      positionClass: 'toast-top-right',
      preventDuplicates: true,
    }),
    //PaymentsModule
  ],
  providers: [
    HTTPStatus,
    MediaSandbox,
    CommonSandbox,
    CommonService,
    AuthSandbox,
    AuthApiService,
    AuthGuard,
    { provide: NgbDateParserFormatter, useClass: NgbDateCustomParserFormatter },
    { provide: HTTP_INTERCEPTORS, useClass: RequestInterceptor, multi: true },
    {
      provide: LocationStrategy,
      useClass: PathLocationStrategy
    }
  ],
  bootstrap: [AppComponent]
})
export class AppModule { }
